import { apiClient } from 'client/core/network/apiClient';
import { IClientConfig } from 'common/config/IClientConfig';

export const ClientConfigApi = {
  getConfig: (opts: {}) => apiClient.get<IClientConfig>(`/config`)
};
